// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2riTH","input":"styles_input__3miRV"};